<div id="carouselIndicators" data-ride="carousel" class="carousel slide carousel-fade">
    <ol class="carousel-indicators">
        <li data-target="#carouselIndicators" data-slide-to="0" class="active"></li>
        <li data-target="#carouselIndicators" data-slide-to="1" class=""></li>
    </ol>
    <div class="carousel-inner">
        <div class="carousel-item active">
            <a href="http://nomiinoboo.com/3Dshuaobao/3D/"><img src="/assets/images/s1.jpg" alt="..." class="d-block w-100"></a>
            <a href="http://nomiinoboo.com/3Dshuaobao/3D/" class="ovoo3d mgl fqg f18">3D ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭ᠎ᠠ ᠶᠢ ᠦᠵᠡᠬᠦ</a>
        </div>
        <div class="carousel-item">
            <a href="http://nomiinoboo.com/museumpano"><img src="/assets/images/s3.jpg" alt="..." class="d-block w-100"></a>
            <a href="http://nomiinoboo.com/museumpano" class="ovoo3d mgl fqg f18" style="padding-top: 22px;">    ᠮᠦᠽᠧᠢ  </a>
        </div>
    </div><a href="#carouselExampleIndicators" role="button" data-slide="prev" class="carousel-control-prev" style="display: none;"><span  aria-hidden="true" class="carousel-control-prev-icon"></span><span  class="sr-only">Previous</span></a>
    <a href="#carouselExampleIndicators" role="button" data-slide="next" class="carousel-control-next" style="display: none;"><span  aria-hidden="true" class="carousel-control-next-icon"></span><span  class="sr-only">Next</span></a>
</div>
<div class="container p-0 position-relative">
    <div class="container mt-5">
        <div class="row justify-content-center">
            <span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq">ᠰᠢᠨ᠎ᠡ ᠨᠡᠮᠡᠭᠰᠡᠨ ᠨᠣᠮ ᠤᠳ</h4>
            <span class="col lpat"></span>
        </div>
        <ngx-glide [showBullets]="false">
            <div>
                <div class="swiper-wrapper mb-5">
                    <div class="swiper-slide ml-0 mr-0 row">
                        <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative mb-4" *ngFor="let nb0 of newBookList0">
                            <img alt="" class="shadow" src="{{url + nb0.bookImage}}">
                            <div class="media-body mgl">
                                <h5 class="m-0 fgq f18">{{nb0.title}}</h5>
                                <a class="stretched-link" href="book/{{ nb0.bookId }}"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="swiper-wrapper mb-5">
                    <div class="swiper-slide ml-0 mr-0 row">
                        <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative mb-4" *ngFor="let nb1 of newBookList1">
                            <img alt="" class="shadow" src="{{ url + nb1.bookImage}}">
                            <div class="media-body mgl">
                                <h5 class="m-0 fgq f18">{{nb1.title}}</h5>
                                <a class="stretched-link" href="book/{{ nb1.bookId }}"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="swiper-wrapper mb-5">
                    <div class="swiper-slide ml-0 mr-0 row">
                        <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative mb-4" *ngFor="let nb2 of newBookList2">
                            <img alt="" class="shadow" src="{{ url + nb2.bookImage}}">
                            <div class="media-body mgl">
                                <h5 class="m-0 fgq f18">{{nb2.title}}</h5>
                                <a class="stretched-link" href="book/{{ nb2.bookId }}"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ngx-glide>
    </div>
</div>
<div class="museum fluid-container bg-white pt-5 pb-5">
    <div class="container">
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq"> ᠮᠣᠩᠭᠣᠯ ᠨᠣᠮ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠮᠦᠽᠧᠢ</h4><span class="col lpat"></span></div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-3 media mgl pl-0" *ngFor="let ml of museumList">
                <img alt="..." class="align-self-center img-thumbnail mb-3" src="{{url + ml.image}}">
                <div class="media-body align-self-center">
                    <a href="{{ml.link}}">
                        <h5 class="m-0 mr-1 fgq f22">{{ml.title}}</h5>
                        <p class="fhw ml-0 mr-0">{{ml.content}}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="celebrity container mt-5 mb-5">
    <div class="row justify-content-center"><span class="col lpat"></span>
        <h4 class="col mgl catName justify-content-center fgq">ᠣᠳᠣᠳ ᠤᠨ ᠭᠢᠯᠪᠠᠭ᠎ᠠ</h4><span class="col lpat"></span></div>
    <div class="row">
        <div class="col-4 col-sm-4 col-md-4 col-lg-2 overflow-hidden" *ngFor="let fl of fameList">
            <a class="media mgl w-100 mb-4" href="profile/{{ fl.peopleId }}">
                <h5 class="position-absolute m-0 mr-1 fgq">{{ fl.peopleName }}</h5>
                <img alt="..." class="align-self-center img-thumbnail w-100" src="{{ url + fl.figure }}">
                <div class="card-body align-self-center w-100 bg-white">
                    <p class="fqg f18 m-0 w-100 p-0">{{ fl.content }}</p>
                </div>
            </a>
        </div>
    </div>
</div>
<div class="activity container pt-0 mb-5">
    <div class="row justify-content-center">
        <span class="col lpat"></span>
        <h4 class="col mgl catName justify-content-center fgq"> ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭᠠᠨ ᠤ ᠰᠢᠷᠢᠰ ᠠᠵᠢᠯᠯᠠᠭ᠎ᠠ</h4>
        <span class="col lpat"></span>
    </div>
    <div class="row">
        <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-3" *ngFor="let sal of sirisAjillagaList">
            <div class="date">{{ sal.publishTime.slice(0,10) }}</div>
            <a class="position-relative d-block" href="video/{{sal.id}}">
                <h5 class="title mgl fqg position-absolute w-100 m-0">
                    <div> {{sal.title}}</div>
                </h5><img alt="" class="img-thumbnail w-100 p-2" src="{{url + sal.mediaFiles[0].path }}"></a>
        </div>
    </div>
</div>